// @flow

import * as atypes from "src/constants/actionTypes";

import type { Action } from "src/types";

const signupError = (state: ?string = null, { type, payload }: Action) => {
  switch (type) {
    case atypes.USER_SIGNUP_REQUEST:
    case atypes.USER_SIGNUP_SUCCESS:
      return null;
    case atypes.USER_SIGNUP_FAILURE:
      return payload.error || "Unable to signup";
    default:
      return state;
  }
};

export default signupError;
